import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { appPaths } from "../../Common";
import { ProtectedRoute } from "../../Auth";
import SearchResultsContainer from "./SearchResultsContainer";
import AdvancedSearchResultsContainer from "./AdvancedSearchResultsContainer";

export const SearchRoutes: React.FC = props => {
  return (
    <Switch>
      <ProtectedRoute path={appPaths.search.results} component={SearchResultsContainer} />
      <ProtectedRoute path={appPaths.search.advanced} component={AdvancedSearchResultsContainer} />
      <Redirect to={appPaths.notFound} />
    </Switch>
  );
};

export default SearchRoutes;
